export class RemoveFoodFromOrder {
  static readonly type = '[Reservation] Remove Food From Order';
  constructor(public id: number) {}
}
